export default class ProfileDetails {

    constructor() {
        if (this.profileDetails = document.querySelectorAll(".profile-details-item")) {
            this._toggleProfileDetails()
        }

        if (this.croppie = document.querySelector(".croppie")) {
            this._croppieEditMode()
        }
    }

    _toggleProfileDetails() {
        var self = this;
        for (let i = 0, l = this.profileDetails.length; i < l; i ++) {
            this.profileDetails[i].addEventListener("click", function(e) {
                const profileDetailsEditLink = this.querySelector(".profile-details-edit-link")
                const profileDetailsCloseButton = this.querySelector(".profile-details-close")

                // show the hidden content inside the profile details item
                if (e.target === profileDetailsEditLink) {
                    e.preventDefault()
                    self._closeAllProfileDetails();
                    this.classList.add("profile-details-item--active")
                }

                // hide the extra content inside the profile details item
                else if (e.target === profileDetailsCloseButton) {
                    e.preventDefault()
                    this.classList.remove("profile-details-item--active")
                }
            })
        }
    }

    _closeAllProfileDetails() {
        for (let i = 0, l = this.profileDetails.length; i < l; i ++) {
            this.profileDetails[i].classList.remove("profile-details-item--active")
        }
    }

    // activates the Croppie edit mode
    _croppieEditMode() {
        const profileImageWrapper = document.querySelector(".profile-image-wrapper")
        profileImageWrapper.addEventListener("click", () => {
            profileImageWrapper.classList.add("hidden")
            this.croppie.classList.add("croppie-active")
        })
    }
}